import React, { PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Spin, Button, Icon } from 'antd';
import PageHeaderLayout from "../../../layouts/PageHeaderLayout";
import { Auth } from '../../../models';
import styles from './index.less';

const mapStateToProps = (state) => {
  const { auth } = state;
  return {
    auth,
  };
};

class UserSettings extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this.props.logged();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.isLoaded && this.props.auth.isLoading === true && nextProps.auth.isLoading === false) {
      this.setState({ isLoaded: true });
    }

    if (this.props.auth && this.props.auth.isLogged === true && nextProps.auth.isLogged === false) {
      this.props.history.push('/login');
    }
  }

  render() {
    const { auth: { user: currentUser, isLogged } } = this.props;
    return (
      <PageHeaderLayout title="Системийн хэрэглэгчийн тохируулга">
        {isLogged ? (
          <Card
            title="Хэрэглэгчийн мэдээлэл"
            className={styles.listCard}
            bordered={false}
            style={{ marginTop: 24 }}
            bodyStyle={{ padding: '40px' }}
          >
            <Row>
              <Col span={24}>
                <Col span={24}><p><b>Нэр:</b> <span>{currentUser.name}</span> </p></Col>
                <Col span={24}><p><b>Мэйл:</b> <span>{currentUser.email}</span></p></Col>
                <Col span={24}><p><b>Нууц үг:</b> <span>{currentUser.password || <div>Харах боломжгүй</div>}</span></p></Col>
                <Col span={24}><p><b>Утас:</b> <span>{currentUser.tel || <div>Оруулаагүй байна.</div>}</span></p></Col>
                <Col span={24}><p><b>Дэлгэрэнгүй мэдээлэл:</b>  <span>{currentUser.description || <span>Оруулагүй байна.</span> }</span></p></Col>
              </Col>
            </Row>
            <Row className={styles.PageFooter}>
              <Col><Button type="primary"><Link to="/"><Icon type="left" /> Буцах</Link></Button></Col>
            </Row>
          </Card>
      ) : <Spin size="small" />

      }
      </PageHeaderLayout>
    );
  }
}

UserSettings.propTypes = {
  auth: PropTypes.object.isRequired,
  logged: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};


UserSettings.defaultProps = {

};

export default connect(mapStateToProps, { logged: Auth.logged })(UserSettings);



// WEBPACK FOOTER //
// ./src/containers/User/Settings/index.js